import gql from 'graphql-tag';
import ItemFragment from '../item/ItemFragment';

const CheckFragment = gql`
  fragment Check on Check {
    taxDetails
    id
    altPaidAmount
    altRefundedAmount
    cashAppliedAmount
    changeAmount
    checkNumber
    cashPaidAmount
    cardPaidAmount
    discountTotal
    gratuityAmount
    iDiscountAmount
    includedTax
    subtotal
    tax
    transactionIdentifier
    total
    registerName
    refundedAmount
    refundedGiftCardAmount
    remainingAmount
    roundingAmount
    items {
      ...Item
    }
  }

  ${ItemFragment}
`;

export default CheckFragment;


// WEBPACK FOOTER //
// ./src/graphql/fragments/order/CheckFragment.js